import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";
import { Image } from "antd";
import noImg from "../../../../../assets/images/not-found.jpg";

export const PanelExterior = ({widthFull}: {widthFull: string}) => {

  const ventoleraDerechaCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.ventoleraDerechaCheckPhoto
  );
  const ventoleraIzquierdaCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.ventoleraIzquierdaCheckPhoto
  );
  const panelIzquierdoCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.panelIzquierdoCheckPhoto
  );
  const panelDerechoCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.panelDerechoCheckPhoto
  );

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <VentoleraIzquierdaPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            ventoleraIzquierdaCheckPhoto ? ventoleraIzquierdaCheckPhoto :  noImg 
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <VentoleraDerechaPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            ventoleraDerechaCheckPhoto ? ventoleraDerechaCheckPhoto : noImg 
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <PanelIzquierdoPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            panelIzquierdoCheckPhoto  ? panelIzquierdoCheckPhoto :  noImg
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <PanelDerechoPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            panelDerechoCheckPhoto ? panelDerechoCheckPhoto : noImg
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
    </Grid>
  );
};

//PANEL EXTERIOR

const VentoleraIzquierdaPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche1,
    handleClose: handleCloseParche1,
    handleOpen: handleOpenParche1,
  } = useOpen();

  const ventoleraIzquierdaPhoto = useWorkflowCheckpointStore(
    (state) => state.ventoleraIzquierdaPhoto
  );

  const setVentoleraIzquierdaPhoto = useWorkflowCheckpointStore(
    (state) => state.setVentoleraIzquierdaPhoto
  );
  const fotoUrl = useBlobUrl(ventoleraIzquierdaPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      label="VENTOLERA IZQUIERDA"
      handleClose={handleCloseParche1}
      handleOpen={handleOpenParche1}
      open={openParche1}
      setFoto={setVentoleraIzquierdaPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const VentoleraDerechaPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche2,
    handleClose: handleCloseParche2,
    handleOpen: handleOpenParche2,
  } = useOpen();

  const ventoleraDerechaPhoto = useWorkflowCheckpointStore(
    (state) => state.ventoleraDerechaPhoto
  );

  const setVentoleraDerechaPhoto = useWorkflowCheckpointStore(
    (state) => state.setVentoleraDerechaPhoto
  );
  const fotoUrl = useBlobUrl(ventoleraDerechaPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche2}
      handleOpen={handleOpenParche2}
      label="VENTOLERA DERECHA"
      open={openParche2}
      setFoto={setVentoleraDerechaPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const PanelIzquierdoPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche3,
    handleClose: handleCloseParche3,
    handleOpen: handleOpenParche3,
  } = useOpen();

  const panelIzquierdoPhoto = useWorkflowCheckpointStore(
    (state) => state.panelIzquierdoPhoto
  );

  const setPanelIzquierdoPhoto = useWorkflowCheckpointStore(
    (state) => state.setPanelIzquierdoPhoto
  );
  const fotoUrl = useBlobUrl(panelIzquierdoPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche3}
      handleOpen={handleOpenParche3}
      label="PANEL IZQUIERDO"
      open={openParche3}
      setFoto={setPanelIzquierdoPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const PanelDerechoPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche3,
    handleClose: handleCloseParche3,
    handleOpen: handleOpenParche3,
  } = useOpen();

  const panelDerechoPhoto = useWorkflowCheckpointStore(
    (state) => state.panelDerechoPhoto
  );

  const setPanelDerechoPhoto = useWorkflowCheckpointStore(
    (state) => state.setPanelDerechoPhoto
  );
  const fotoUrl = useBlobUrl(panelDerechoPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche3}
      handleOpen={handleOpenParche3}
      label="PANEL DERECHO"
      open={openParche3}
      setFoto={setPanelDerechoPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};
